import React from 'react';
import { LucideIcon, Search, X } from 'lucide-react';

interface CustomSelectInputProps {
    label?: string | React.ReactNode;
    value?: string | React.ReactNode;
    placeholder?: string;
    icon?: LucideIcon;
    onClick: () => void;
    onClear?: () => void;
    disabled?: boolean;
    className?: string;
}

export const CustomSelectInput: React.FC<CustomSelectInputProps> = ({
    label,
    value,
    placeholder = "Seçiniz...",
    icon: Icon,
    onClick,
    onClear,
    disabled = false,
    className = ""
}) => {
    return (
        <div className={`flex flex-col gap-1.5 w-full ${className}`}>
            {label && (
                <label className="text-xs font-bold text-text/70 uppercase tracking-wide flex items-center gap-1.5">
                    {label}
                </label>
            )}
            <div 
                onClick={!disabled ? onClick : undefined}
                className={`
                    flex items-center gap-3 px-3 py-2.5 rounded-lg border 
                    transition-all duration-200
                    ${disabled 
                        ? 'bg-bgAlt border-borderColor/50 cursor-not-allowed opacity-70' 
                        : 'bg-inputBg border-borderColor hover:border-primary/50 cursor-pointer group hover:shadow-sm'
                    }
                `}
            >
                {Icon && (
                    <Icon size={18} className={`shrink-0 ${value ? 'text-primary' : 'text-text/40 group-hover:text-primary/70'} transition-colors`} />
                )}
                
                <div className="flex-1 truncate">
                    {value ? (
                        <span className="font-semibold text-inputText text-[13px]">{value}</span>
                    ) : (
                        <span className="text-text/40 text-[13px] font-medium">{placeholder}</span>
                    )}
                </div>
                
                {value && onClear && !disabled ? (
                    <button 
                        type="button"
                        onClick={(e) => {
                            e.stopPropagation();
                            onClear();
                        }}
                        className="shrink-0 p-1 rounded-md hover:bg-bgAlt text-text/50 hover:text-danger transition-colors"
                        title="Temizle"
                    >
                        <X size={14} />
                    </button>
                ) : (
                    !disabled && (
                        <div className="shrink-0 w-6 h-6 rounded-md bg-primary/10 text-primary flex items-center justify-center group-hover:bg-primary group-hover:text-white transition-all shadow-sm">
                            <Search size={14} />
                        </div>
                    )
                )}
            </div>
        </div>
    );
};
